import { CompetenciaInput } from '@core/components/Inputs';
import { PageHeader } from '@core/components/PageHeader';
import Tour from '@core/components/Tour';
import { useApiUtils } from '@core/util/apiUtils';
import { acompanharReguaCobranca } from '@core/util/mockTourUtils';
import FusePageCarded from '@fuse/core/FusePageCarded';
import { Grid } from '@material-ui/core';
import SelectReguaCobranca from 'app/components/Select/SelectReguaCobranca';
import { reguaCobrancaApi } from 'app/services/api/reguaCobrancaApi';
import { usuarioApi } from 'app/services/api/usuarioApi';
import * as Actions from 'app/store/actions';
import { GlobalContext } from 'app/store/globalcontext';
import { FormikProvider, useFormik } from 'formik';
import React, { useContext, useEffect, useState } from 'react';
import { FaRulerHorizontal } from 'react-icons/fa';
import { useDispatch } from 'react-redux';
import { AcompanharReguaCobrancaContext, AcompanharReguaCobrancaProvider } from './AcompanharReguaCobrancaContext';
import AcompanharTimeLine from './components/AcompanharTimeLine';
import { AcompanharReguaCobrancaModais } from './components/Modal/AcompanharReguaCobrancaModais';
import VisualizarCobrancaModal from './components/Modal/VisualizarCobranca/VisualizarCobrancaModal';
import { acompanharReguaCobrancaSteps } from './steps/AcompanharReguaCobrancaSteps';

const AcompanharReguaCobranca = () => {
  const [modal] = useContext(AcompanharReguaCobrancaContext).modal;
  const [, setLoading] = useContext(AcompanharReguaCobrancaContext).loading;
  const [funcionalidadesTour, setFuncionalidadesTour] = useContext(GlobalContext).funcionalidadesTour;
  const [card, setCard] = useState([]);
  const [run, setRun] = useState(false);
  const [, setTour] = useState(false);

  const dispatch = useDispatch();
  const apiUtils = useApiUtils(dispatch, Actions);

  useEffect(() => {
    if (!funcionalidadesTour) {
      setFuncionalidadesTour([]);
    }
    buscarTour();
    // Efeito de montagem: roda uma única vez. Incluir as dependências reexecutaria a carga
    // inicial a cada render (loop de chamadas à API).
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const initialValues = {
    reguaCobranca: {},
    competencia: undefined,
  };

  const formik = useFormik({
    initialValues,
  });

  const reguaCobrancaSelecionada =
    formik.values?.reguaCobranca &&
    Object.keys(formik.values?.reguaCobranca).length !== 0 &&
    formik.values?.reguaCobranca !== null;

  const buscarTour = async () => {
    const funcionalidadeJaExistente = funcionalidadesTour?.some((e) => e === 'ACOMPANHAR_REGUA_COBRANCA');
    if (!funcionalidadeJaExistente) {
      setRun(true);
      setTour(true);
      setCard(acompanharReguaCobranca.content);
    }
  };

  const fetchReguaCobranca = async (reguaCobrancaId, competencia) => {
    setLoading(true);
    try {
      const resp = await reguaCobrancaApi().montarCardReguaCobranca(reguaCobrancaId, competencia.format('YYYY-MM-DD'));
      setCard(resp.data);
    } catch (err) {
      apiUtils.handleApiError(err);
    } finally {
      setLoading(false);
    }
  };

  const atualizarTour = async () => {
    try {
      setLoading(true);
      funcionalidadesTour.push('ACOMPANHAR_REGUA_COBRANCA');
      await usuarioApi.updateTour(funcionalidadesTour);
      setRun(false);
      setTour(false);
      setFuncionalidadesTour(funcionalidadesTour);
      setCard([]);
    } catch (err) {
      apiUtils.handleApiError(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <FusePageCarded
      header={
        <PageHeader title="Acompanhar régua de cobrança" icon={<FaRulerHorizontal />}>
          <div />
        </PageHeader>
      }
      content={
        <FormikProvider value={formik}>
          <>
            <Tour
              steps={acompanharReguaCobrancaSteps}
              run={run}
              setRun={setRun}
              onFinish={() => atualizarTour()}
              disableScrolling={true}
            />
          </>
          <Grid container style={{ padding: 16 }}>
            <Grid item xs={6} sm={6} md={6} xl={6} lg={6} className="stepEscolhaRegua" style={{ paddingRight: 15 }}>
              <SelectReguaCobranca
                id="reguaCobranca"
                name="reguaCobranca"
                label="Escolha a régua"
                onChange={(event) => {
                  formik.handleChange(event);
                  if (formik.values?.competencia !== undefined && event.target.value) {
                    fetchReguaCobranca(event.target.value?.id, formik.values?.competencia);
                  }
                }}
                onBlur={formik.handleBlur}
                value={formik.values?.reguaCobranca}
                required
              />
            </Grid>
            <Grid item xs={6} sm={6} md={6} lg={6} xl={6} style={{ paddingLeft: 15 }}>
              <CompetenciaInput
                id="competencia"
                fullWidth
                label="Competência"
                value={formik.values?.competencia}
                onBlur={formik.handleBlur}
                onChange={(event) => {
                  formik.handleChange(event);
                  if (reguaCobrancaSelecionada) {
                    fetchReguaCobranca(formik.values?.reguaCobranca?.id, event.target.value);
                  }
                }}
                format="MM/YYYY"
                required
              />
            </Grid>

            <Grid item xs={12} sm={12} md={12} xl={12} lg={12} style={{ marginTop: 30 }}>
              <AcompanharTimeLine card={card} />
              {modal === AcompanharReguaCobrancaModais.visualizarCobranca && <VisualizarCobrancaModal />}
            </Grid>
          </Grid>
        </FormikProvider>
      }
    />
  );
};

const AcompanharReguaCobrancaContainer = () => (
  <AcompanharReguaCobrancaProvider>
    <AcompanharReguaCobranca />
  </AcompanharReguaCobrancaProvider>
);

export default AcompanharReguaCobrancaContainer;
